import { Fault } from '../../damage/models/fault.model';

export class QuickValuationLookupData {
  quoteId: number;
  quoteGuid: string;
  vrm: string;
  mileage: number;
  fault: Fault;
  isManualLookup: boolean;
  capId: number;
  
  keys: number;
  serviceHistoryId: number;
  previousOwners: number; // Should be Keepers, but Owners already exists in backend model
  isVatRegistered: boolean;

  emailAddress: string;
  telephoneNumber: string;
  emailOptIn: boolean;

  constructor(quoteId, quoteGuid, vrm, mileage, fault, isManualLookup, capId) {
    this.quoteId = quoteId;
    this.quoteGuid = quoteGuid;
    this.vrm = vrm;
    this.mileage = mileage;
    this.fault = fault;
    this.isManualLookup = isManualLookup;
    this.capId = capId;
  }
}
